import { useTheme } from "../contexts/ThemeContext";

const assets = {
  logo: require("../assets/logo-full.png"),
  logoDark: require("../assets/logo-full.png"),
};

interface Props {
  href?: string;
  className?: string;
}

const LogoHorizontal: React.FC<Props> = ({className, href }) => {
  const { theme } = useTheme();
  return (
    <img
      src={theme === 'dark' ? assets.logoDark : assets.logo}
      alt="Logo"
      className={className}
      style={{ cursor: href ? "pointer" : "default" }}
      onClick={() => href && window.open(href, "_blank")} // Open in new tab
    />
  );
};

export default LogoHorizontal;
